import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { useRef as f, useEffect as u } from "react";
import { RocheUIHeroVariant as d } from "../../types/roche-hero-variant.js";
import e from "./roche-staging-hero.module.scss.js";
const R = ({
  variant: s = d.VARIANT_A,
  headline: a,
  content: o,
  Image: n,
  slot: l
}) => {
  const h = s === d.VARIANT_B, c = f(null), m = [e["staging-hero"], e[s]].filter(Boolean).join(" ");
  u(() => {
    var g;
    const t = (g = c.current) == null ? void 0 : g.closest("roche-grid");
    return t && (t.setAttribute("no-padding", "true"), t.setAttribute("data-staging-hero", s)), () => {
      t && (t.removeAttribute("no-padding"), t.removeAttribute("data-staging-hero"));
    };
  }, [s]);
  const _ = h && n;
  return /* @__PURE__ */ i("section", { ref: c, className: m, "data-variant": s, slot: l, children: [
    /* @__PURE__ */ i("div", { className: e["staging-hero__wrapper"], children: [
      /* @__PURE__ */ r("div", { className: e["staging-hero__background"] }),
      /* @__PURE__ */ i("div", { className: e["staging-hero__content"], children: [
        /* @__PURE__ */ r("div", { className: e["staging-hero__letter"] }),
        a && /* @__PURE__ */ r("h1", { className: e["staging-hero__headline"], children: a }),
        o && /* @__PURE__ */ r("p", { className: e["staging-hero__text"], children: o })
      ] }),
      /* @__PURE__ */ r("div", { className: e["staging-hero__divider"] })
    ] }),
    _ && /* @__PURE__ */ r("div", { className: e["staging-hero__image"], children: n })
  ] });
};
export {
  R as RocheUIStagingHero
};
